import { useEffect, useRef } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _RemoteAbstractAction, _single } from "../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";

interface Props {
    invoke: any;    
    isComplete: Function;
}

export const ExecBackAction = ({ invoke, isComplete }: Props) => {
    const { instance } = useDataBean(_RemoteAbstractAction);
    
    const intervalRef = useRef<NodeJS.Timeout | null>(null); // 🔵 useRef para persistir el intervalo
    const veces = useRef<number>(0);

    useEffect(() => {
        sendData();
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [invoke.IDApplicationInvoker]);

    const sendData = () => {
        console.log("INVOKE EN BACK => ",invoke);
        
        instance.setRemoteAbstractActionProperties(invoke.IDApplicationInvoker, {}, _single.getAccountID())
            .then((resp: any) => {
                _single.printOut("RESPONSE BACK => ");
                _single.printOut(resp);

                if (resp) {
                    if (resp.MESSAGE !== '') {
                        toast.warn(resp.MESSAGE);
                    } else if (resp.RESPONSE_ID === 1) {
                        isComplete(true);                        
                    }
                    else
                        waitProcess();
                }
            })
            .catch(err => {
                console.error(err);
                waitProcess();
            });
    };

    const waitProcess = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current); // 🔵 Limpia si ya existía
        }
        
        intervalRef.current = setInterval(() => {
            console.log("waitProcess = CONSULTANDO => ", invoke.IDApplicationInvoker);

            instance.getApplicationInvoker(invoke.IDApplicationInvoker)
                .then((resp: any) => {
                    console.log("INVOKE BACK PROCESS => ", resp);
                    if (resp.State === 1 || resp.State === 2) {
                        if (intervalRef.current) {
                            clearInterval(intervalRef.current); 
                        }
                        isComplete(true);
                    }
                    veces.current = veces.current+1;
                    // if(veces.current>3)
                    // {
                    //     clearInterval(intervalRef.current); 
                    //     isComplete(true);
                    // }
                })
                .catch(err => {
                    console.error("Error consultando aplicación: ", err);
                });
        }, 20000);
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    );
};
